<template>
  <v-card outlined>
    <v-card-title>Основные настройки</v-card-title>
    <v-card-text>
      <TextField class="pt-0" label="Название" v-model="shop.name" 
        :original_value="original_value ? original_value.name : undefined"
      />
      <TextField label="Адрес" v-model="shop.address"
        :original_value="original_value ? original_value.address : undefined"
      />
      <TextField multiline label="Описание" v-model="shop.description" 
        :original_value="original_value ? original_value.description : undefined"
      />
      <!-- <v-row>
        <v-col cols="12"><v-label>Типы заказа</v-label></v-col>
        <v-col class="pt-0" cols="6" v-for="(type, index) in order_types" :key="index">
          <v-checkbox class="mt-0" :label="type.label" :value="type.value" v-model="selected">
          </v-checkbox>
        </v-col>
      </v-row> -->
    </v-card-text>
  </v-card>
</template>

<script>
import TextField from '../../ui/TextField.vue';

export default{
  props: {
    value: Object,
    original_value: Object,
  },
  data: () => ({
    selected: ['DELIVERY']
  }),
  computed:{
    order_types(){
      return [{label: 'Доставка', value: 'DELIVERY'}, {label: 'Самовывоз', value: 'TAKEAWAY'}]
    },
    shop: {
      set(v){
        this.$emit('input', v)
      },
      get(){
        return this.value
      }
    },
    order_type: {
      get(){
        return this.shop.order_type_map
      },
      set(v){
        this.shop = {...this.shop, order_type_map: v}
      }
    }
  },

  watch: {
    selected(val, old_val){
      if(val.length === 0){
        this.selected = [old_val[0] === 'DELIVERY' ? 'TAKEAWAY' : 'DELIVERY']
      }

      this.order_type = this.selected
    }
  },

  components:{
    TextField
  }
}
</script>